/* istanbul ignore file */
import { CREATE_SERVICE_CATALOG, useServiceCatalogUrl } from 'domain/shared/serviceCatalog';
import { CreateButton } from 'framework/ui/ui-builder';

const CreateServiceCatalogButton = () => {
  const { getCreateUrl } = useServiceCatalogUrl();

  return (
    <CreateButton
      url={getCreateUrl()}
      label="Add service"
      key="create-service"
      permissionToCheck={CREATE_SERVICE_CATALOG}
    />
  );
};

export default CreateServiceCatalogButton;
